import Vue from 'vue'
import axios from 'axios'
import mMessage from '@/common/message'
import storage from '@/common/storage.js'
import router from '@/router'
//import utils from '@/common/utils'
Vue.prototype.$http = axios

// 门户登录页路由名，需与 router/index.js 中 PortalLogin 保持一致
const LOGIN_ROUTE_NAME = 'PortalLogin'
// 并发请求同时 401 时的跳转节流，避免重复弹提示/重复跳转
let lastRedirectAt = 0

/**
 * 判断响应体是否为未登录(code=401)
 * 后端 R.UNLOGIN 常量值为字符串 "401"，这里兼容字符串/数字两种返回
 */
function isUnLogin(body) {
  return !!body && String(body.code) === '401'
}

/**
 * 统一处理登录失效：清理本地登录态，并跳转到门户登录页(携带 redirect 回跳地址)
 * 已在登录页时不重复跳转，避免死循环
 */
function redirectToLogin(msg) {
  try {
    // 是否曾经登录过(用于区分"登录已过期"与"尚未登录")
    const hadLogin = !!storage.getString('portalMember')
    storage.removeString('token')
    storage.removeString('portalMember')
    // 清除"未登录"标记，让 PortalLayout 下次可重新探测登录态
    storage.removeString('portalNoLogin')
    // 当前已在登录页：只做清理，不再跳转
    const current = router.currentRoute || {}
    console.warn('[api] 触发401跳转, 当前路由:', current.fullPath || '', 'name:', current.name || '')
    if (current.name === LOGIN_ROUTE_NAME) {
      console.warn('[api] 已在登录页, 仅清理本地登录态')
      return
    }
    const now = Date.now()
    if (now - lastRedirectAt < 1000) {
      console.warn('[api] 1秒内已处理过401, 跳过')
      return
    }
    lastRedirectAt = now
    const message = msg || (hadLogin ? '登录已过期，请重新登录' : '请先登录后再操作')
    mMessage.error(message)
    const query = current.fullPath ? { redirect: current.fullPath } : {}
    router.push({ name: LOGIN_ROUTE_NAME, query }).then(() => {
      console.warn('[api] 已跳转到门户登录页, redirect=', current.fullPath || '')
    }).catch((err) => {
      console.error('[api] 跳转门户登录页失败:', err)
    })
  } catch (e) {
    console.error('[api] redirectToLogin 内部异常:', e)
  }
}

const learn = {
  lean_section(data) {
    return ajax('/api/front/plan/learn/private/section', 'post', { data })
  },
  learn_begin(data){
    return ajax('/api/front/h5/coursevideo/private/beginLearn', 'post', { data })
  },
  play_video_auth(data) {
    return ajax('/api/front/h5/coursevideo/private/getVideoPlayAuth', 'post', { data })
  },
  learn_progress_collect(data){
    return ajax('/api/front/h5/coursevideo/private/learnProgressCollect', 'post', { data })
  },
  enter_live(params){
    return ajax('/api/front/h5/courselive/private/enterLive', 'post', { params })
  },
  // AI上课-开始上课：后端建立课堂会话并启动课堂推进线程，返回 sessionId 字符串（不是对象）
  // 前端拿到 sessionId 后连接 WebSocket(/api/audio?sessionId=xxx)，接收逐页下发的课件
  // 后端为 @RequestParam(roomId, studentId, courseWareId)，必须走 query
  // studentId：家长账号可能绑多个孩子，由 enterLive 下发；后端用它校验该学生确在本直播间，并绑定课堂会话
  begin_class(params){
    return ajax('/api/front/h5/courselive/private/beginClass', 'post', { params })
  },
}

// 门户端登录相关API
const portalApi = {
  // 获取滑块验证码：返回带缺口的背景图与拼图块，缺口坐标只存服务端、不下发
  captcha_slider() {
    return ajax('/api/open/login/captcha/slider', 'post', {})
  },
  // 校验滑块拖动偏移量，通过后拿到一次性票据 captchaTicket
  captcha_slider_check(data) {
    return ajax('/api/open/login/captcha/slider/check', 'post', { data })
  },
  // 发送登录验证码，不需要openId；params 需带滑块验证通过的一次性票据 captchaTicket
  send_yzm(params) {
    return ajax('/api/open/login/web/sendYzm', 'post', { params })
  },
  // 手机验证码登录，成功后服务端下发Cookie
  mobile_login(data) {
    return ajax('/api/open/login/web/mobileLogin', 'post', { data })
  },
  // 退出登录
  logout() {
    return ajax('/api/open/login/web/logout', 'post', {})
  },
  // 获取当前登录会员信息
  current_member() {
    // silent：匿名访问时不要弹错误提示、也不要跳登录页
    return ajax('/api/open/login/front/currentLoginMember', 'post', { silent: true })
  },
}

// 判题系统-自定义题型(customize)-考生答题相关API
const hojCustomizeExamApi = {
  // 我的考试列表
  // options.silent=true 时不跳登录页(用于门户首页匿名浏览场景)
  hoj_customize_exam_list(options) {
    return ajax('/api/front/web/hoj/customize/exam/private/list', 'post', {
      silent: !!(options && options.silent)
    })
  },
  // 开始考试
  hoj_customize_exam_begin(data) {
    return ajax('/api/front/web/hoj/customize/exam/private/begin', 'post', { data })
  },
  // 考试记录详情（断点续答/查看成绩）
  hoj_customize_exam_detail(data) {
    return ajax('/api/front/web/hoj/customize/exam/private/detail', 'post', { data })
  },
  // 提交单题答案
  hoj_customize_exam_answer(data) {
    return ajax('/api/front/web/hoj/customize/exam/private/answer', 'post', { data })
  },
  // 提交整场考试
  hoj_customize_exam_submit(data) {
    return ajax('/api/front/web/hoj/customize/exam/private/submit', 'post', { data })
  },
}

// 判题系统-核心题目(problem)-门户做题相关API
const hojProblemApi = {
  // 题目列表
  hoj_problem_list(data) {
    return ajax('/api/front/web/hoj/problem/private/list', 'post', { data })
  },
  // 题目详情
  hoj_problem_detail(data) {
    return ajax('/api/front/web/hoj/problem/private/detail', 'post', { data })
  },
  // 题目可选题语言列表
  hoj_problem_language_list(data) {
    return ajax('/api/front/web/hoj/problem/private/language/list', 'post', { data })
  },
  // 提交评测
  hoj_problem_submit(data) {
    return ajax('/api/front/web/hoj/problem/private/submit', 'post', { data })
  },
  // 在线自测
  hoj_problem_test(data) {
    return ajax('/api/front/web/hoj/problem/private/test', 'post', { data })
  },
  // 我的提交记录列表
  hoj_problem_judge_list(data) {
    return ajax('/api/front/web/hoj/problem/private/judge/list', 'post', { data })
  },
  // 提交记录详情
  hoj_problem_judge_detail(data) {
    return ajax('/api/front/web/hoj/problem/private/judge/detail', 'post', { data })
  },
}

// 商城-商品浏览、购物车、收藏相关API
const shopApi = {
  // 课程分类列表（首页一级筛选）
  course_cate() {
    return ajax('/api/front/miniprogram/home/public/queryCourseCate', 'post', { data: {} })
  },
  // 商品分类列表（首页二级筛选）
  comm_cates() {
    return ajax('/api/front/miniprogram/home/public/queryCommCates', 'post', { data: {} })
  },
  // 分类+商品列表（分页，R.ok(page) 走 data）
  comms_and_cates(data) {
    return ajax('/api/front/miniprogram/home/public/queryCommsAndCates', 'post', { data })
  },
  // 商品详情，后端为 @RequestParam commId，必须走 query
  query_comm(params) {
    return ajax('/api/front/miniprogram/home/public/queryComm', 'get', { params })
  },
  // 是否已加购，返回 "1"/"0"
  is_shop_car(params) {
    return ajax('/api/front/miniprogram/shop/private/isShopCar', 'get', { params })
  },
  // 切换加购状态
  update_shop_car(params) {
    return ajax('/api/front/miniprogram/shop/private/updateShopCar', 'get', { params })
  },
  // 是否已收藏，返回 "1"/"0"
  is_shop_favorite(params) {
    return ajax('/api/front/miniprogram/shop/private/isShopFavorite', 'get', { params })
  },
  // 切换收藏状态
  update_shop_favorite(params) {
    return ajax('/api/front/miniprogram/shop/private/updateShopFavorite', 'get', { params })
  },
  // 购物车列表（分页）
  query_shop_car(data) {
    return ajax('/api/front/miniprogram/shop/private/queryShopCar', 'post', { data })
  },
  // 收藏列表（分页）
  query_shop_favorite(data) {
    return ajax('/api/front/miniprogram/shop/private/queryShopFavorite', 'post', { data })
  },
}

// 用户中心-小主档案、客服相关API
const userCenterApi = {
  // 小主（学生）列表，R.ok(List) 走 rows
  student_list() {
    return ajax('/api/front/miniprogram/usercenter/private/student/list', 'post', { data: {} })
  },
  // 新增小主
  student_add(data) {
    return ajax('/api/front/miniprogram/usercenter/private/student/add', 'post', { data })
  },
  // 编辑小主
  student_edit(data) {
    return ajax('/api/front/miniprogram/usercenter/private/student/edit', 'post', { data })
  },
  // 删除小主
  student_delete(data) {
    return ajax('/api/front/miniprogram/usercenter/private/student/delete', 'post', { data })
  },
  // 客服(老师)企微二维码
  customer_qrcode() {
    return ajax('/api/front/miniprogram/usercenter/private/customer/service/qrcode', 'get', { params: {} })
  },
}

// 学习报告相关API
const reportApi = {
  // 学习计划列表（分页，R.ok(page) 走 data）
  report(data) {
    return ajax('/api/front/plan/learn/private/report', 'post', { data })
  },
}

// 我的订单相关API
// 门户端支付终端类型固定为 2（网页二维码支付）：后端微信 Native 下单，把 code_url 当作二维码内容返回
const orderApi = {
  // 订单列表（分页，R.ok(page) 走 data）
  order_list(data) {
    return ajax('/api/front/order/private/list', 'post', { data })
  },
  // 订单详情，后端为 @RequestParam orderNo，必须走 query
  order_detail(params) {
    return ajax('/api/front/order/private/detail', 'get', { params })
  },
  // 取消订单（仅待支付状态可取消）
  order_cancel(data) {
    return ajax('/api/front/order/private/cancel', 'post', { data })
  },
  // 订单核销（订单行核销，选择小主后确认）
  order_verification(data) {
    return ajax('/api/front/order/private/verification', 'post', { data })
  },
  // 支付预请求：paymentClientType 必传 '2'，门户端不传 openId（后端仅小程序支付校验该字段）
  // 续付已有订单时只传 orderNo，后端会自动重建 totalPrice/items；R.ok(resVo) 走 data
  order_payment_request(data) {
    return ajax('/api/front/order/private/payment/request', 'post', { data })
  },
  // 支付结果查询：后端为 @RequestParam paymentNo，必须走 query
  order_payment_result(params) {
    return ajax('/api/front/order/private/result/request', 'get', { params })
  },
  // 申请退款：门户端只提交申请单，真正退款由后台审核通过后执行
  order_refund_request(data) {
    return ajax('/api/front/order/private/refund/request', 'post', { data })
  },
}

//导出管理端API接口
let api = Object.assign(learn, portalApi, hojCustomizeExamApi, hojProblemApi, shopApi, userCenterApi, reportApi, orderApi)
export default api
/**
 * @param url
 * @param method get|post|put|delete...
 * @param params like queryString. if a url is index?a=1&b=2, params = {a: '1', b: '2'}
 * @param data post data, use for method put|post
 * @returns {axios}
 */
function ajax(url, method, options) {
  // silent=true 时不弹全局错误提示、也不跳登录页（用于匿名可访问的探测类接口）
  let params = {}, data = {}, silent = false
  if (options !== undefined) {
    params = options.params || {}
    data = options.data || {}
    silent = options.silent === true
  }
  return new Promise((resolve, reject) => {
    // 鉴权说明：登录/授权后服务端已通过 Set-Cookie 下发 Authorization Cookie(可能为 HttpOnly)，
    // 浏览器会随同源请求自动携带该 Cookie，服务端拦截器优先取请求头、取不到时自动回落从 Cookie
    // 读取 token，因此这里不再手动设置 Authorization 请求头，避免用本地 storage 残留的旧 token
    // 覆盖 Cookie 中服务端下发的有效 token，导致鉴权走旧值而失败。
    const config = {
      url,
      method,
      params,
      data,
      // 同域/跨子域场景下都需要自动携带服务端下发的 Authorization Cookie
      withCredentials: true
    };

    axios(config).then((res) => {
      // 处理响应
      if (isUnLogin(res.data)) {
        // token过期或无效：统一跳转门户登录页
        if (!silent) {
          redirectToLogin(res.data.msg)
        }
        reject(res);
      } else {
        resolve(res);
      }
    }).catch(error => {
      // 静默模式：不弹提示、不跳登录，交由调用方自行处理
      if (silent) {
        reject(error);
        return;
      }
      // 处理网络错误
      const resp = error.response;
      if (resp) {
        // HTTP 401 或响应体 code=401，统一跳转门户登录页
        if (resp.status === 401 || isUnLogin(resp.data)) {
          redirectToLogin(resp.data && resp.data.msg);
        } else {
          mMessage.error('请求失败，请稍后再试');
        }
      } else {
        mMessage.error('网络错误，请检查您的网络连接');
      }
      reject(error);
    });
  });
}

